import React,{useEffect} from 'react'
import logo from "../../assets/images/therame.svg";
export default function FAQ() {
    document.title = "Therame-FAQ"
    useEffect(() => {
        document.body.style.backgroundColor = "#252735";
        return () => {
            document.body.style.backgroundColor = "";
        };
    }, []);
    return (
         <>
                    <div className="container-fluid px-0">
                        <div className="container-fluid py-3" style={{ backgroundColor: '#1d1e28' }}>
                            <img src={logo} width="232" alt="The TEA Group Logo" />
                        </div>
                    </div>
                    <div className="container text-center mt-4">
                        <h4 className="text-white">FAQ</h4>
                    </div>
                </>
    )
}
